import React from 'react'

const WelcomeBack = () => {
  return (
    <h1 className="text-2xl font-medium">Welcome Back</h1>
  )
}

export default WelcomeBack